module.exports = __webpack_public_path__ + "img/airlink_logo.82591353.svg";